<template>
  <div>
    <v-toolbar color="#DFE3E5" height="40px" elevation="0">
      <v-container class="py-0 container-large justify-end d-flex top-links">
        <router-link to="/" class="text-decoration-none px-4"
          >Ouvidoria</router-link
        >
        <router-link to="fale-conosco" class="text-decoration-none px-4"
          >Fale Conosco</router-link
        >
        <router-link to="trabalhe-conosco" class="text-decoration-none px-4"
          >Trabalhe Conosco</router-link
        >
      </v-container>
    </v-toolbar>
    <v-app-bar color="white" height="120px" elevation="0">
      <v-container class="py-0 container-large">
        <v-sheet
          width="100%"
          height="100%"
          color="transparent"
          class="d-flex justify-space-between align-center"
        >
          <div class="d-flex align-center">
            <router-link to="/">
              <img
                v-if="informations.img"
                class="d-block"
                :src="files + informations.img"
                :alt="informations.name"
                height="70px"
              />
            </router-link>

            <div
              v-if="informations.img_center || informations.img_foundation"
              class="d-flex flex-column ml-6"
            >
              <v-card
                v-if="informations.img_center"
                v-bind="getLinkAttrs(externalLinks.college_website)"
                flat
                tile
              >
                <img
                  class="d-block"
                  :src="files + informations.img_center"
                  width="128px"
                />
              </v-card>

              <v-card
                v-if="informations.img_foundation"
                :class="{ 'mt-3': informations.img_center }"
                v-bind="getLinkAttrs(externalLinks.foundation_website)"
                flat
                tile
              >
                <img
                  class="d-block"
                  :src="files + informations.img_foundation"
                  width="128px"
                />
              </v-card>
            </div>
          </div>

          <div>
            <div class="d-flex align-center justify-end">
              <v-btn text class="phone">
                <v-icon size="20px" color="primary" class="mr-2"
                  >fas fa-phone-alt</v-icon
                >
                <span>{{ informations.tel }}</span>
              </v-btn>
              <v-btn
                text
                class="phone"
                v-bind="getLinkAttrs(informations.whatsapp_float)"
              >
                <v-icon size="20px" color="primary" class="mr-2"
                  >fab fa-whatsapp</v-icon
                >
                <span>{{ informations.whatsapp }}</span>
              </v-btn>
            </div>
            <div class="d-flex align-center mt-3">
              <div>
                <div
                  v-for="({ text, to, dropdown }, keyMenu) in menu"
                  :key="keyMenu"
                  class="d-inline-flex"
                >
                  <v-btn
                    v-if="!dropdown"
                    class="
                      text-caption text-xl-body-2 text-none
                      font-weight-medium
                      px-2 px-lg-3
                      py-5
                      nav-link
                    "
                    v-bind="getLinkAttrs(to)"
                    active-class="nav-link-active"
                    depressed
                    tile
                    text
                  >
                    {{ text }}
                  </v-btn>

                  <v-menu v-else offset-y tile>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="
                          text-caption text-xl-body-2 text-none
                          font-weight-medium
                          px-2
                          py-5
                          mx-xl-2
                          nav-link
                        "
                        color="grey"
                        active-class="nav-link-active"
                        depressed
                        tile
                        text
                      >
                        {{ text }}

                        <v-icon class="ml-1 ml-xl-2" color="primary" size="12">
                          fa-chevron-down
                        </v-icon>
                      </v-btn>
                    </template>

                    <v-list color="primary" tile>
                      <v-list-item
                        v-for="(item, keyDropdown) in dropdown"
                        :key="keyDropdown"
                        v-bind="getLinkAttrs(item.to)"
                      >
                        <v-list-item-title
                          class="white--text text-body-2 font-weight-medium"
                        >
                          {{ item.text }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import { menu } from "../../../config";
import { getLinkAttrs } from "../../../utils/getLinkAttrs";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    externalLinks() {
      return this.$rest("external-links").item;
    },
  },
  methods: {
    getLinkAttrs,
  },
  mixins: [menu],
};
</script>

<style lang="scss" scoped>
.nav-link {
  &:before {
    opacity: 0 !important;
  }
}
.top-links a {
  font-size: 16px;
  color: #7c7e80;
  text-transform: none !important;
}

.phone {
  font-size: 20px !important;
  font-weight: bold !important;
}
</style>
